var isGalleryLoaded = false;
$(document).ready(function() {
  applyJustifiedGallery();
  detectJustifiedGallery();

  $(window).resize(function() {
    forceReloadGallery();
  });

  setInterval(function() {
    if (document.getElementById("snize-option-selector-2")) {
      if (document.getElementById("snize-option-selector-2").options.length > 1) {
        document.getElementById("snize-option-selector-2").options[
          document.getElementById("snize-option-selector-2").options.length - 1
        ] = null;
      }
    }
  }, 300);

  /*setInterval(function() {
    $('a').each(function() {
      if ($(this).attr('href').indexOf('shopify2.wallmonkeys.com') !== -1) {
        $(this).attr('href', $(this).attr('href').replace('shopify2.wallmonkeys.com', 'www.wallmonkeys.com'));
      }
    });
  }, 500);*/
});

function forceReloadGallery() {
  isGalleryLoaded = false;
  console.log("reload the gallery!");
  applyJustifiedGallery();
}

function detectJustifiedGallery() {
  if (isGalleryLoaded) {
    if ($("div#widget_disabled_opacity").is(":visible")) {
      forceReloadGallery();
    }
  }
  setTimeout(function() {
    detectJustifiedGallery();
  }, 1);
}

function applyJustifiedGallery() {
  if (isGalleryLoaded) return;

  var targ = $(".snize-search-results-content.clearfix");
  if (!targ.length || $("div#widget_disabled_opacity").is(":visible")) {
    setTimeout(function() {
      applyJustifiedGallery();
    }, 1);
    return;
  }

  $(".snize-item.clearfix").each(function() {
    $(this)
      .find(".snize-overhidden")
      .hide();
    $(this).mouseover(function() {
      $(this)
        .find(".snize-overhidden")
        .show();
      $(this)
        .find(".snize-title")
        .attr("style", "display: inline !important");
    });
    $(this).mouseout(function() {
      $(this)
        .find(".snize-overhidden")
        .hide();
    });
  });

  isGalleryLoaded = true;
  console.log("gallery reloaded");
  return;
  $("div#snize-search-results-grid-mode").html(
    $("div#snize-search-results-grid-mode")
      .html()
      .replace(/<ul class="snize-product jg-entry entry-visible" /g, "<div")
      .replace(/<\/ul>/g, "</div>")
      .replace(/<li/g, "<div")
      .replace(/<\/li>/g, "</div>")
  );
  targ = $(".snize-search-results-content.clearfix");
  targ.justifiedGallery({
    rowHeight: 180,
    maxRowHeight: 240,
    margins: 12,
    images: ".product_related_item",
    lastRow: "justify",
    waitThumbnailsLoad: false
  });
  console.log("initialized applyJustifiedGallery");
}
